import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';
import 'moment/locale/el';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import 'dayjs/locale/el';
import { ConfigProvider } from 'antd';
import el_GR from 'antd/es/locale/el_GR';

dayjs.extend(customParseFormat);
dayjs.extend(LocalizedFormat);
dayjs.locale('el');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
moment().locale('el');

const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') ?? "/";
root.render(
  <BrowserRouter basename={baseUrl}>
    <ConfigProvider
      locale={el_GR}
      theme={{
        token: {
          // Primary brand color — clinical teal
          colorPrimary: "#0f9b8e",
          colorSuccess: "#2d8a4e",
          colorWarning: "#d4880a",
          colorError: "#c0392b",
          colorInfo: "#0f9b8e",
          colorLink: "#0f9b8e",

          // Typography
          fontSize: 14,
          fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,

          // Shape — slightly squared for clinical precision
          borderRadius: 4,
          borderRadiusLG: 6,
          borderRadiusSM: 2,

          // Controls — slightly taller for better touch targets
          controlHeight: 34,

          // Subtle shadow and borders
          boxShadow: "0 1px 3px 0 rgba(0,0,0,0.10), 0 1px 2px 0 rgba(0,0,0,0.06)",
          boxShadowSecondary: "0 4px 6px -1px rgba(0,0,0,0.08), 0 2px 4px -1px rgba(0,0,0,0.04)",
        },
        components: {
          Checkbox: {
            lineWidth: 2,
            colorBgContainer: "#f0faf9"
          },
          Menu: {
            itemSelectedColor: "#0f9b8e",
            itemSelectedBg: "#e6f7f6",
            itemHoverColor: "#0c8278",
            itemHoverBg: "#f0faf9",
          },
          Table: {
            headerBg: "#f0faf9",
            headerColor: "#1a3a38",
            rowHoverBg: "#f7fdfc",
          },
          Card: {
            headerBg: "#f8fffe",
          },
          Button: {
            borderRadius: 4,
          },
          Badge: {
            colorBgContainer: "#0f9b8e",
          }
        }
      }}
    >
      <App />
    </ConfigProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
